import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Popper, useHover } from '../../../../ui';
import { $sectionsData } from '../../model';
import * as Styled from './styled';

export const SectionDescriptionButton = () => {
  const { t } = useTranslation();
  const sectionsData = useUnit($sectionsData);
  const { anchorEl, hover, handleMouseIn, handleMouseOut } = useHover('span');

  const description = sectionsData?.description;

  return description ? (
    <Styled.Container onMouseOver={handleMouseIn} onMouseOut={handleMouseOut}>
      <Popper
        style={{ minWidth: 300, zIndex: 2 }}
        open={hover}
        header={t('SectionDescription')}
        anchorEl={anchorEl}
      >
        {description}
      </Popper>

      <Styled.Icon fontSize="small" />
    </Styled.Container>
  ) : null;
};
